



























































import { Component } from 'vue-property-decorator';
import LessonBaseMixin from '@/components/ViewComponent/ELearning/lesson-base-mixin';
import GraduationHatIcon from '@/components/Helper/Icon/Svg/GraduationHatIcon.vue';
import { mixins } from 'vue-class-component';
import HasSideDrawerMixin from '@/mixin/Layout/has-side-drawer-mixin';
import { UseService } from '@/services/service';
import LessonTestQuestionService from '@/services/lesson-test-question.service';
import { LessonTestQuestionEntity } from '@/entities/lesson-test-question.entity';
import CheckedIcon from '@/components/Helper/Icon/Svg/CheckedIcon.vue';
import CDivider from '@/components/Helper/CDivider.vue';

@Component<TestResult>({
  components: { CDivider, CheckedIcon, GraduationHatIcon },
})
export default class TestResult extends mixins(
  LessonBaseMixin,
  HasSideDrawerMixin,
) {
  @UseService(LessonTestQuestionService)
  questionService: LessonTestQuestionService;

  questions: LessonTestQuestionEntity[] = [];

  async mounted(): Promise<void> {
    this.questions = await this.questionService.getManyByLessonId(
      this.lessonId,
    );
  }
}
